
import React from "react";

import {
    BrowserRouter,
    Switch,
    Redirect,
    Route,
    Link,
    NavLink
} from "react-router-dom";


import { HeaderMobile } from './HeaderMobile.jsx'
import { HeaderTablet } from './HeaderTablet.jsx'

export class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = { redirectTo: '/', redirectToState: {}, currencyisEuro: null }

        this.redirectDone = true;
        this.movementNeeded = 40;


        this.windowScroll = this.windowScroll.bind(this);
        this.showUser = this.showUser.bind(this);
        this.logout = this.logout.bind(this);
        this.doRedirect = this.doRedirect.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.checkFloatingElement = this.checkFloatingElement.bind(this);
        this.changeCurrency = this.changeCurrency.bind(this);

        if (!casino.config.fromNativeApp) {
            this.oldScroolTop = 0;
            this.currentHeaderClass = '';
            document.addEventListener("scroll", this.windowScroll, { passive: true });
        }

        this.header = React.createRef();
    }

    componentDidMount() {
        if (!casino.config.fromNativeApp) {
            this.movementNeeded = 40;
            var headerHeight = this.header.current.clientHeight || 40;
            if (headerHeight > 50)
                this.movementNeeded = headerHeight * 0.35;
        }
        if (!localStorage.getItem('activeCurrency') || localStorage.getItem('activeCurrency') == 'kn') {
            localStorage.setItem('activeCurrency', 'eur')
        }

        let currencyisEuro = localStorage.getItem('activeCurrency') == 'eur' ? true : false;
        this.setState({ currencyisEuro: currencyisEuro });
    }

    changeCurrency(currencyisEuro) {
        this.setState({ currencyisEuro: currencyisEuro });
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.windowScroll);
        cancelAnimationFrame(this.animationFrame);
    }

    windowScroll() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = requestAnimationFrame(this.checkFloatingElement);
    }

    checkFloatingElement() {

        var newClass = "";
        // ako je menu prikazan , onda ne skrivamo header
        if (this.props.showMenu) {
            newClass = 'plivaj no-animation';
        } else {
            // ako menu nije prikazan, onda drž nedaj, ovo je dosta komplicirano da rade i animacije i ios
            var curentScroolTop = window.scrollY;
            var deltaX = curentScroolTop - this.oldScroolTop;
            this.oldScroolTop = curentScroolTop;

            if (curentScroolTop <= 0) {
                newClass = 'plivaj';
            } else if (deltaX > this.movementNeeded) {
                newClass = 'skriveno';
            } else if (deltaX < -10) {
                newClass = 'plivaj';
            }
        }

        if (newClass && newClass != this.currentHeaderClass) {

            if (this.currentHeaderClass.indexOf('plivaj') >= 0)
                this.header.current.classList.remove('plivaj');
            if (this.currentHeaderClass.indexOf('no-animation') >= 0)
                this.header.current.classList.remove('no-animation');
            if (this.currentHeaderClass.indexOf('skriveno') >= 0)
                this.header.current.classList.remove('skriveno');

            newClass.split(' ').map(x => this.header.current.classList.add(x));

            this.currentHeaderClass = newClass;
        }
    }

    showUser(user, sesijaId) {
        this.props.updateUserFn(user, sesijaId);
    }

    logout(redirectToHome) {
        var that = this;

        this.props.showLoadingFn(true);
        casino.repos.sessionRepo.remove().then(function () {
            that.showUser(null, null);
            that.props.showLoadingFn(false);
        });

        if (redirectToHome) {
            that.doRedirect(this.props.getHomePathFn(this.props.route.location));
        }
    }
    doRedirect(path, state) {
        this.redirectDone = false;
        this.setState({
            redirectTo: path,
            redirectToState: state
        });
    }
    toggleMenu() {


        var showMenu = !this.props.showMenu;
        this.props.showMenuFn(showMenu);




        // fix header if needed
        this.windowScroll();
    }

    closeAndroidDlBanner() {
        this.props.closeAndroidDlBannerFn();
    }

    setDoNotReminder() {
        let expires = 1000 * 60 * 60 * 24 * 90; //90 days
        casino.utils.setLocalStorageWithExpiry("android-dl-banner-is-closed", true, expires);
    }

    createGoogleTagEvent() {
        casino.utils.createGoogleTagManagerEvent({
            'event': 'casino_app_download',
            'os': casino.utils.getOperatingSystem()
        });
    }

    renderAndroidAppDlBanner() {
        return <div className="download-android-app-banner tablet-hidden">
            <div className="download">
                <a href="https://mcasino.supersport.hr/download"
                    onClick={() => {
                    this.setDoNotReminder();
                    this.createGoogleTagEvent();
                }} target="_blank">
                    <span className="dl-image"></span>
                </a>

                <div className="text">
                    <h3>Unaprijedi iskustvo igranja</h3>
                    <span>Preuzmi novu Casino aplikaciju</span>
                </div>

            </div>
            <div className="right-container">
                <a href="https://mcasino.supersport.hr/download"
                    onClick={() => {
                    this.setDoNotReminder();
                    this.createGoogleTagEvent();
                }} target="_blank">
                    <button className="btn outline small fill green ">PREUZMI</button>
                </a>
                <span className="icon" onClick={() => this.closeAndroidDlBanner()}></span>
            </div>
        </div>

    }

    render() {


        if (casino.config.fromNativeApp && !this.props.nativeAppVisible)
            return null;

        return <div className={"header-container"} >
{/*            {window.location.href.toLowerCase().includes("poker") && <div className="poruka-banner2" style={{ height: '7rem' }} ><div className="novo-banner-upgrade2"><span className="icon ico-info"></span> <span>Zbog radova na poboljšanju i unaprijeđenju sustava mogući su prekidi u radu poker aplikacije u periodu od 06:00h do 09:00h</span></div></div>}*/}

            {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
            {this.redirectDone = true}

            <section id="header" ref={this.header} className="plivaj no-animation">
                {this.renderAndroidAppDlBanner()}
                <div className="mobile clearfix">
                    <HeaderMobile {...this.props} {...this.state} changeCurrency={this.changeCurrency} toggleMenuFn={this.toggleMenu} logoutFn={this.logout} />
                </div>
                <div className="tablet clearfix">
                    <HeaderTablet {...this.state} {...this.props} changeCurrency={this.changeCurrency} showUserFn={this.showUser} doRedirectFn={this.doRedirect} logoutFn={this.logout} />
                </div>
            </section>
        </div>

    }
};
